import * as qs from 'qs';
export function getQueryVariable(key) {
    // if (!key) return '';
    const query = window.location.search.slice(1);
    return key ? qs.parse(query)[key] : '';
}
const cleanQuery = (query, initialData) => Object.keys(query ?? {}).reduce((acc, key) => {
    if (!query)
        return acc;
    if (query[key] === initialData[key]) {
        return acc;
    }
    acc[key] = query[key];
    return acc;
}, {});
export function isURL(value) {
    const reg = /[\w#%()+./:=?@~]{2,256}\.[a-z]{2,6}\b([\w#%&+./:=?@~-]*)/g;
    const regLocahostAndIPURL = /^http(s)?:\/\/\w+(\.\w+)*(:\d+)?\/?(\/[\w.]*)*$/;
    const isValid = (reg.exec(value)?.length ?? 0) > 0 ||
        (regLocahostAndIPURL.exec(value)?.length ?? 0) > 0;
    return isValid;
}
// Invite messages are templated prose with the verification URL embedded.
// Pulls out just the URL, or null when the message has none.
export function extractUrl(text) {
    return /https?:\/\/\S+/.exec(text)?.[0].replace(/[).,;:]+$/, '') ?? null;
}
export const pushFiltersSearchPath = ({ filter, initialData, mapData, path, excludeKeys }) => {
    let acc = {};
    for (const key of Object.keys(filter)) {
        if (excludeKeys?.includes(key))
            continue;
        const k = key;
        if (filter[k] !== null && filter[k] !== undefined && filter[k] !== '')
            acc[key] = filter[k];
    }
    const existQuery = cleanQuery(transformQueryTypes(mapData, rawParseQuery()), initialData);
    acc = cleanQuery(acc, initialData);
    if (!isQueriesSame(existQuery, acc)) {
        const params = qs.stringify(acc);
        const targetPath = `${path}${params ? `?${params}` : ''}`;
        window.history.pushState('', '', targetPath); // can't use react-router here, still adds history w/o reload
    }
    return {
        isInitial: isQueriesSame(acc, cleanQuery(initialData, initialData))
    };
};
export const isQueriesSame = (q1, q2) => {
    // same size?
    const q1Len = Object.keys(q1).length;
    const q2Len = Object.keys(q2).length;
    if (q1Len !== q2Len) {
        return false;
    }
    return !Object.keys(q1).some((key) => {
        const a = q1[key];
        const b = q2[key];
        if (a instanceof Date && b instanceof Date) {
            return a.getTime() !== b.getTime();
        }
        return a !== b;
    });
};
export const rawParseQuery = (query = window.location.search.slice(1)) => {
    if (!query) {
        return {};
    }
    return qs.parse(query);
};
export const transformQueryTypes = (struct, obj) => {
    const out = {};
    for (const k of Object.keys(struct)) {
        if (obj[k] === undefined || obj[k] === null)
            continue;
        // Skip empty string for non-string types where '' produces invalid conversions (NaN, false, Invalid Date)
        if (obj[k] === '' && struct[k] !== 'string')
            continue;
        let value;
        // eslint-disable-next-line @typescript-eslint/switch-exhaustiveness-check
        switch (struct[k]) {
            case 'boolean': {
                if (obj[k] === 'true' || obj[k] === true)
                    value = true;
                else if (obj[k] === 'false' || obj[k] === false)
                    value = false;
                break;
            }
            case 'number': {
                const n = Number(obj[k]);
                if (!Number.isNaN(n))
                    value = n;
                break;
            }
            case 'date': {
                const d = new Date(obj[k]);
                if (!Number.isNaN(d.getTime()))
                    value = d;
                break;
            }
            case 'string': {
                value = obj[k];
                break;
            }
            default:
                break;
        }
        if (value !== undefined)
            out[k] = value;
    }
    return out;
};
export const toQueryStringWithArraySupport = (filters) => {
    let params = '';
    for (const [key, value] of Object.entries(filters)) {
        if (value !== '' && value !== null && value !== undefined) {
            params += key === 'ids' ? `${key}=["${value}"]&` : `${key}=${value}&`;
        }
    }
    return params;
};
